import React from "react";
import { connect } from "react-redux";
import { loadTabs } from "../../../Header/actions";

import Roles from "./Roles/roles";
import Perfiles from "./Perfiles/view";
import Empresas from "./Empresas/view";
// import Notifiicacion from "./Notificaciones/view";
// import { doGetCompanyNotificaction } from "../../Mantenedores/Notificaciones/actions";

import { getPerfiles, getRoles, getEmpresas } from "./../General/actions";

import { checkAccess, ids } from "../../../../helpers/rolAccess";

class Mantenedores extends React.PureComponent {
  constructor(props) {
    super(props);

    if (!props.roles.length) props.dispatch(getRoles(true));
    if (!props.perfiles.length) props.dispatch(getPerfiles());
    if (!props.empresas.length) props.dispatch(getEmpresas());
  }

  componentDidUpdate = (prevProps) => {
    if ((prevProps.userAccessIds === null && Array.isArray(this.props.userAccessIds))
      || this.props.currentHeader !== "General") {
      this.loadTabs();
    }
  }

  loadTabs = () => {
    const tabs = [];
    if (checkAccess(ids.perfiles, this.props.userAccessIds)) tabs.push({ text: "Empresas", contentId: 0 });
    if (checkAccess(ids.roles, this.props.userAccessIds)) tabs.push({ text: "Roles", contentId: 1 });
    if (checkAccess(ids.perfiles, this.props.userAccessIds)) tabs.push({ text: "Perfiles", contentId: 2 });

    this.props.dispatch(loadTabs("General", "", tabs, tabs.length ? tabs[0].contentId : null));
  }

  renderBody = () => {
    switch (this.props.selectedTab) {
      case 0:
        return <Empresas />;
      case 1:
        return <Roles />;
      case 2:
        return <Perfiles />;
      default:
        return <div />;
    }
  }

  render() {
    return (
      <div className={"mantenedoresGenerales"}>
        {this.renderBody()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedTab: state.header.contentId,
  currentHeader: state.header.title,
  roles: state.mantenedores.roles,
  perfiles: state.mantenedores.perfiles,
  empresas: state.mantenedores.empresas,
  userAccessIds: state.global.userAccessIds,
  companyId: state.global.companyId,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(Mantenedores);
